/* eslint-disable @next/next/no-img-element */
import React, { FC } from "react";
import { Link } from "./link";
import { ContentManager } from "./content-manager";
import type { ContentfulCallToActionType } from "@/types";

interface Props {
  className?: string;
  cta: ContentfulCallToActionType;
  theme?: "dark" | "light";
}

export const Cta: FC<Props> = ({ className, cta, theme }) => {
  return (
    <div className={`cta ${className || ""} ${theme ? theme : ""}`}>
      <div className="cta--inner">
        {cta?.text && (
          <ContentManager content={cta.text} className="cta--text" />
        )}
        {cta?.buttonLabel && cta.buttonFile?.file?.url && (
          <Link
            href={`https:${cta.buttonFile.file.url}`}
            target="_blank"
            theme="white"
            fill="full"
            title={cta.buttonLabel}
            className="cta--link"
          >
            <span>{cta.buttonLabel}</span>
          </Link>
        )}
        {cta?.buttonLabel && cta.buttonLink && (
          <Link
            href={cta.buttonLink}
            theme="white"
            fill="full"
            title={cta.buttonLabel}
            className="cta--link"
          >
            <span>{cta.buttonLabel}</span>
          </Link>
        )}
      </div>
      <img
        src={
          theme
            ? theme === "light"
              ? "/images/spiral.webp"
              : "/images/spiral-2.webp"
            : "/images/spiral-2.webp"
        }
        alt="Spiral"
        width={theme === "light" ? 1332 : 0}
        height={theme === "light" ? 1555 : 0}
        role="presentation"
        draggable={false}
        className="cta--spiral"
      />
    </div>
  );
};
